export default (array) => {
  return array.filter((value, index, self) => {
    return index === self.findIndex((item) => item.id === value.id);
  });
};
